import { TBoxGift } from "./types";

export const MEAL_PLAN_GIFT_BY_BOX_NUMBER: TBoxGift = {
  // 1: "TOTE_BAG", TODO: Add tote bag back when told to do so
};
export const LITTER_PLAN_GIFT_BY_BOX_NUMBER: TBoxGift = {};
